import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/alarms',
  component: Management,
  redirect: '/alarms/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/alarms/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listAlarms
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/alarms/ListTable'),
          meta: {
            auth: Auth.listAlarms,
            tabName: 'all'
          }
        },
        // 解除状态
        {
          path: 'unresolved',
          component: () => import('@/views/alarms/ListTable'),
          meta: {
            auth: Auth.listAlarms,
            tabName: 'unresolved'
          }
        },
        {
          path: 'resolved',
          component: () => import('@/views/alarms/ListTable'),
          meta: {
            auth: Auth.listAlarms,
            tabName: 'resolved'
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/alarms/DetailLayout'),
      children: [
        {
          path: 'detail',
          component: () => import('@/views/alarms/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showAlarm
          }
        }
      ]
    }
  ]
}
